import { styled, xStyledCommonProps } from '@elliemae/ds-system';
import { DSAccordionName, DSAccordionSlots } from '../../constants/index.js';

export const StyledContainer = styled('div', {
  name: DSAccordionName,
  slot: DSAccordionSlots.CONTAINER,
})`
  min-width: 240px;
  ${xStyledCommonProps};
`;
